/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import Draggable from 'react-draggable';
import AudioCallsHeader from './Components/AudioCallsHeader';
import AudioCallsFooter from './Components/AudioCallFooter';
import './styles.css';
import { CallContext, LanguageContext } from '../../../../../../../libs/Context';
import { store } from '../../../../../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { PRESENCE_ENUMS } from '../../../../../../../libs/enums/presenceEnums';
import FullScreen from '../FullScreen';
import { setAudioCall } from '../../../../../../../redux/CallsRedux';

type DragState = {
    start: boolean;
    stop: boolean;
    drag: boolean;
};

const AudioCalls = (props) =>
{
	const { localStreamRef, remoteStreamRef, reconectionRef } = props;
	const [ max, setMax ] = useState(false);
	const { language } = useContext(LanguageContext);
	const callDetails:any = store?.getState()?.mypresence.callDetails;
	const callData = useSelector((state:any) => state?.call);
	const session = useSelector((state:any) => state?.mysession?.session);
	const { updateCallDetails, peerConnectionClose } = useContext(CallContext);
	const [ duration, setDuration ] = useState<number>(0);
	const dispatch = useDispatch();

	const dotCount = 3;
	const [ drag, setDrag ] = useState<DragState>({
		start : false,
		stop  : false,
		drag  : false
	});
	const handleMaxScreen = () =>
	{
		setMax(!max);
	};

	const handleDragState = (key: keyof DragState) =>
	{
		setDrag((prev) => ({
			...prev,
			[key] : !prev[key] // Properly toggle the state
		}));
	};

	const getCallStatus = () =>
	{
		const status = callDetails?.type === 'group' ? callDetails?.participants[session?.userId]?.status : callDetails?.status;

		switch (status)
		{
			case 'connected':
				return language?.ongoing;
			case 'accepted':
				return 'connecting';
			case 'ringing':
				return language?.ringing;
			default:
				return callData?.audioCall === PRESENCE_ENUMS.incoming ? language?.incoming : callData?.audioCall === PRESENCE_ENUMS.initiated ? language?.calling : language?.ringing;
		}
	};

	const handleEndCall = async () =>
	{
		updateCallDetails(PRESENCE_ENUMS.ended, duration, callDetails);
		if (callData?.audioCall === PRESENCE_ENUMS.onGoing)
		{
			dispatch(setAudioCall(''));
		}
		peerConnectionClose(callDetails?.callId);
	};

	useEffect(() =>
	{
		if (callDetails?.status === 'connected')
		{
			const interval = setInterval(() =>
			{
				setDuration((prevSeconds) => prevSeconds + 1);
			}, 1000);

			return () => clearInterval(interval);
		}
	}, [ callDetails?.status ]);

	const callerData:any = callDetails && Object.values(callDetails?.participants)?.find((i:any) => i?.id !== session?.userId);
	const initiatorData:any = callDetails?.type === 'group' && callDetails?.initiator
		? Object.values(callDetails?.participants || {})?.find((i:any) => i?.id === callDetails?.initiator)
		: null;

	const getImageUrl = useCallback(() =>
	{
		if (callDetails?.type === 'group' && callDetails?.groupIcon)
		{
			return callDetails?.groupIcon;
		}

		if (callDetails?.type === PRESENCE_ENUMS.individual)
		{
			// if (callerData?.profileImg && callerData?.profileImg.trim() !== '')
			// {
			// 	return callerData?.profileImg;
			// }

			// If profileImg is not available, try S3 URL pattern
			if (callerData?.id)
			{
				return `${process.env.REACT_APP_S3_BASE_URL}/profile/${callerData?.id}_profile.jpeg?t=${Date.now().valueOf()}`;
			}
		}

		// Fallback to default image
		return '/images/icons/defaultUser.svg';
	}, [ callDetails?.type, callDetails?.groupIcon, callerData?.id ]);

	const imageRef = useRef<string>(getImageUrl());

	const handleErrorImage = () =>
	{
		imageRef.current = '/images/icons/defaultUser.svg';
	};

	return (

		<Draggable
			onStart={() => handleDragState('start')}
			onStop={() => handleDragState('stop')}
			onDrag={() => handleDragState('drag')}
			bounds='parent'
			disabled={max}
		>
			{!max
				? (
					<Box
						sx={{
							position             : 'absolute',
							top                  : '30%',
							zIndex               : 1011,
							background           : 'rgba(35, 164, 196, 0.1)',
							borderRadius         : '13px',
							cursor               : 'grab',
							boxShadow            : '0px 4px 6px rgba(0,0,0,0.1)',
							backdropFilter       : 'blur(8px)',
							WebkitBackdropFilter : 'blur(8px)',
							display              : 'flex',
							right                : '25%',
							flexDirection        : 'column',
							height               : max ? '380px' : '320px',
							width                : max ? '330px' : '250px'				}}
					>
						<AudioCallsHeader
							handleMaxScreen={handleMaxScreen}
							onGoingCall={[ 'connected' ].includes(callDetails?.status)}
							duration={duration}
						/>
						{ [ PRESENCE_ENUMS.initiated, PRESENCE_ENUMS.incoming, PRESENCE_ENUMS.outGoing ].includes(callData?.audioCall) && <audio autoPlay hidden preload='auto' loop>
							<source
								src={callData?.audioCall === PRESENCE_ENUMS.incoming ? '/audio/ringone.mp3' : '/audio/ringone.mp3'}
								type='audio/mpeg'
							/>
							Your browser does not support the audio element.
						</audio>}
						<Stack
							direction='column'
							alignItems='center'
							justifyContent='center'
							spacing={1}
							// flexGrow={1}
							p={1}
						>
							<Typography variant='inherit' fontSize={max ? 22 : 16} fontWeight={500} px={1}
								sx={{
									display      : 'inline-block',
									whiteSpace   : 'nowrap',
									overflow     : 'hidden',
									textOverflow : 'ellipsis',
									width        : '100%',
									textAlign    : 'center'
								}}
							>
								{callDetails?.type === 'group' ? (callDetails?.groupName || language?.groupCall) : callerData?.name ?? ''}
							</Typography>
							{callDetails?.type === 'group' && initiatorData && callDetails?.initiator !== session?.userId && (
								<Typography variant='inherit' fontSize={max ? 14 : 12} fontWeight={400} color='text.secondary' px={1}
									sx={{
										display      : 'inline-block',
										whiteSpace   : 'nowrap',
										overflow     : 'hidden',
										textOverflow : 'ellipsis',
										width        : '100%',
										textAlign    : 'center'
									}}
								>
									{`${language?.groupCall || 'Group call'} by ${initiatorData?.name || 'Unknown'}`}
								</Typography>
							)}
							{callDetails?.status !== 'connected' &&
							<Stack direction='row' spacing={0.5} alignItems='baseline' lineHeight={0}>
								<Typography variant='inherit'>
									{reconectionRef ? 'Reconecting' : getCallStatus()}
								</Typography>
								<Stack direction='row' spacing={0.5}>
									{Array.from({ length: dotCount }).map((_, index) => (
										<Stack key={index}>
											<Typography className='dots' style={{ animationDelay: `${index * 0.3}s` }} />
										</Stack>
									))}
								</Stack>
							</Stack>
							}
						</Stack>

						<Stack
							direction='column'
							spacing={1}
							alignItems='center'
							justifyContent='center'
							flexGrow={1}
							p={1}
							mt={1}
						>

							<Box
								height={120}
								width={120}
								borderRadius='50%'
								sx={{
									overflow       : 'hidden',
									background     : 'linear-gradient(135deg, rgba(35, 164, 196, 0.2) 0%, rgba(35, 164, 196, 0.4) 100%)',
									display        : 'flex',
									alignItems     : 'center',
									justifyContent : 'center'
								}}
							>
								<img
									src={imageRef?.current || '/images/icons/defaultUser.svg'}
									alt='profile'
									draggable={false}
									style={{
										borderRadius : '50%',
										height       : '100%',
										width        : '100%',
										objectFit    : 'cover'
									}}
									onError={handleErrorImage}
								/>
							</Box>
							{/* animation */}
							{ [ 'connected' ].includes(callDetails?.status) &&
							// <SpeakingVoice stream={remoteStreamRef} user={callerData}/>
							<Stack direction='row' justifyContent='center' alignItems='center' className='speaker' spacing={0.5} >
								<Typography className='lines line1' />
								<Typography className='lines line2' />
								<Typography className='lines line3' />
								<Typography className='lines line4' />
								<Typography className='lines line5' />
							</Stack>
							}

						</Stack>
						<AudioCallsFooter
							onGoingCall={[ 'connected' ].includes(callDetails?.status)}
							handleEndCall={handleEndCall}
						/>
					</Box>
				)
				: (
					<FullScreen
						handleMaxScreen={handleMaxScreen}
						handleEndCall={handleEndCall}
						duration={duration}
						callType='audio'
						callerData={callerData}
						reconectionRef={reconectionRef}
					/>
				)}
		</Draggable>

	);
};

export default AudioCalls;
